.CalendarView {
  height: 75vh;
  min-height: 600px;
}
